import Dexie from 'dexie';
import dayjs from 'dayjs';

const DbName = 'PcareerMasterBaseData';

const oneDayLaterDate = dayjs().add(1, 'day');

const URL_TABLE_MAP = {
  '/api/v2/public/data/areas': 'areas',
  '/api/v2/public/data/prefectures': 'prefectures',
  '/api/v2/public/data/cities': 'cities',
  '/api/v2/public/data/lines': 'lines',
  '/api/v2/public/data/stations': 'stations',
  '/api/v2/public/data/commute_stations': 'commute_stations',
  '/api/v3/public/selections/codes?category=pharmacist&group=position_type': 'position_types',
  '/api/v3/public/selections/codes?category=pharmacist&group=specialty': 'specialties',
  '/api/v3/public/selections/codes?category=pharmacist&group=employment_type': 'employment_types',
  '/api/v3/public/selections/codes?category=pharmacist&group=needs': 'position_tags',
}

class IndexedDbManager {
  constructor() {
    if (!IndexedDbManager.indexedDbManager) {
      this.db = new Dexie(DbName);
      IndexedDbManager.indexedDbManager = this;
    }

    return IndexedDbManager.indexedDbManager;
  }

  createTables() {
    this.db.version(1).stores({
      ['areas']: 'id, name, prefectureIds, kind',
      ['prefectures']: 'id, name, stationIds, cityIds, lineIds, kind',
      ['cities']: 'id, name, kind',
      ['lines']: 'id, name, railroadName, kind',
      ['stations']: 'id, name, kind',
      ['commute_stations']: 'id, name, line_name, station_id, kind',
      ['position_types']: 'id, code, name, text, kind',
      ['specialties']: 'id, code, name, text, kind',
      ['employment_types']: 'id, code, name, text, kind',
      ['position_tags']: 'id, code, name, text, category, kind',
      ['expired_times']: 'id, expired_at',
    });
  }

  // 有効時間をチェックしてテーブルを削除
  async checkExpiredTables() {
    let expired_time = await this.db.expired_times.toCollection().first();

    // 有効時間が設定されていない場合はセットする
    if (!expired_time) {
      this.db.expired_times.put({id: 1, expired_at: oneDayLaterDate.format()});
      return;
    }

    // キャッシュ期間が7日の時代があった
    // 反映したい変更を最大で1週間待ちたくない
    // 現在設定しているキャッシュ期間以上にキャッシュ期間を設定されていた場合は現状のキャッシュ期間に上書く
    if (new Date(expired_time.expired_at) > oneDayLaterDate) {
      Object.values(URL_TABLE_MAP).map(table_name => {
        this.clearTable(table_name);
      });
      this.db.expired_times.put({id: 1, expired_at: oneDayLaterDate.format()});
    }
    
    // 有効時間過ぎていたらテーブルを削除、有効時間を再セット
    if (new Date(expired_time.expired_at) < new Date()) {
      Object.values(URL_TABLE_MAP).map(table_name => {
        this.clearTable(table_name);
      });
      this.db.expired_times.put({id: 1, expired_at: oneDayLaterDate.format()});
    }
  }

  // マスターデータのURL一覧を返す
  masterUrls() {
    return Object.keys(URL_TABLE_MAP);
  }

  // URLに対応するテーブルが存在するか
  isIndexedDbTables(url) {
    return URL_TABLE_MAP[url] != null;
  }

  // テーブルにデータを追加
  async addDataList(url, data_list) {
    let table = URL_TABLE_MAP[url];
    await this.db[table].bulkPut(data_list);
  }

  // テーブルをクリア
  async clearTable(table) {
    await this.db[table].clear();
  }

  // テーブルにデータが存在するか
  async isExistsData(url) {
    let table = URL_TABLE_MAP[url];
    return await this.db[table].count() > 0;
  }

  // テーブルから全データを取得
  async getAll(url) {
    let table = URL_TABLE_MAP[url];
    if (!table) return;
    return await this.db[table].toArray();
  }
}

const indexedDbManager = new IndexedDbManager();
indexedDbManager.createTables();
Object.freeze(indexedDbManager);

export default indexedDbManager;
